<template>
  <b-form-group
    :label="$t('fields.team')"
    label-for="id_teams"
  >
    <v-select
      v-model="dataItem.id_teams"
      :options="teamsList"
      label="title"
      :reduce="item => item.id"
      :placeholder="$t('fields.selectTeam')"
      clearable
      :disabled="!dataItem.id_departments"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'GuidesTeamsCard',
  components: { BFormGroup, vSelect },
  computed: {
    teamsList() {
      return this.$store.getters['teams/dataList']
    },
    dataItem() {
      return this.$store.getters['guides/dataItem']
    },
  },
  created() {
    this.getTeams()
  },
  methods: {
    getTeams() {
      const where = { 'teams.status': 1 }
      if (this.dataItem.id_departments) {
        where['teams.id_departments'] = this.dataItem.id_departments
      }
      this.$store.dispatch('teams/getDataList', {
        select: [
          'teams.id AS id',
          'teams.title AS title',
        ],
        where,
      })
    },
  },
}
</script>
